import { offers, news } from '../services/ApiService';
import { offersConstants } from '../constants/offers';
import axios from 'axios';

// EDIT_OFFER

export const setOfferToMy = (id, updates) => ({
  type: offersConstants.SET_OFFER_TO_MY,
  id,
});

// SET_OFFERS
export const setOffers = (offers = [], ammounts = {}) => ({
  type: offersConstants.SET_OFFERS_LIST_SUCCESS,
  offers,
  ammounts,
});

export const setOfferFilters = (filters = {}) => ({
  type: offersConstants.SET_OFFER_FILTERS_SUCCESS,
  filters,
});

export const startSetOffers = params => dispatch => {
  dispatch({ type: offersConstants.SET_OFFERS_LIST_REQUEST });
  return offers
    .getList(params)
    .then((data = {}) => {
      dispatch(setOfferFilters(data.filters));
      return dispatch(setOffers(data.items, data.amounts));
    })
    .catch(err => {
      if (axios.isCancel(err)) return ({type: offersConstants.CANCEL_REQUEUS})
      return ({ type: offersConstants.SET_OFFERS_LIST_FAILURE })
    });
};

// SEARCH OFFERS
export const startSearchOffers = params => dispatch =>
  offers.searchOffer(params).then((data = { items: [] }) => {
    const result = { id: data.items.map(offer => offer.id) };
    return dispatch(setOffersCatalogFilter(result));
  });

//
// данные теперь приходят с запросом getList
//
// SET_OFFERS_FILTERS
// export const startSetOffersFilters = () => dispatch => {
//   dispatch({ type: offersConstants.SET_OFFER_FILTERS_REQUEST });

//   return offers
//     .getFilters()
//     .then(data => dispatch(setOfferFilters(data.items)))
//     .catch(err => ({ type: offersConstants.SET_OFFER_FILTERS_FAILURE }));
// };

// RESET_CATALOG_FILTERS
export const resetOffersCatalogFilter = name => ({
  type: offersConstants.RESET_OFFERS_CATALOG_FILTER,
  name,
});

// SET_CATALOG_FILTERS
export const setOffersCatalogFilter = (filter = {}) => ({
  type: offersConstants.SET_OFFERS_CATALOG_FILTER,
  filter,
});

export const setOffersTabs = tabs => ({
  type: offersConstants.SET_OFFERS_TABS_SUCCESS,
  tabs,
});

export const startSetOffersTabs = () => dispatch => {
  dispatch({ type: offersConstants.SET_OFFERS_TABS_REQUEST });

  return offers
    .getTabs()
    .then((data = {}) => dispatch(setOffersTabs(data.items)))
    .catch(err => ({ type: offersConstants.SET_OFFERS_TABS_FAILURE }));
};

// SET_OFFER_INFO
export const setOfferInfo = (offer = {}) => ({
  type: offersConstants.SET_OFFER_SUCCESS,
  offer,
});

export const startSetOfferInfo = offerId => dispatch => {
  return offers
    .getOfferInfo(offerId)
    .then((data = { items: [] }) => dispatch(setOfferInfo(data.items[0])))
    .catch(err => ({ type: offersConstants.SET_OFFER_FAILURE }));
};

export const setOffer = (offer = {}) => ({
  type: offersConstants.SET_OFFER_SUCCESS,
  offer,
});

export const startSetOffer = offerId => dispatch => {
  return offers
    .getOffer(offerId)
    .then((data = { items: [] }) => dispatch(setOffer(data.items[0])))
    .catch(err => ({ type: offersConstants.SET_OFFER_FAILURE }));
};

export const resetOffer = () => ({
  type: offersConstants.RESET_OFFER,
  offer: {},
});

// SET_OFFER_NEWS
export const setOfferNews = (news = []) => ({
  type: offersConstants.SET_OFFER_NEWS_SUCCESS,
  news,
});

export const startSetOfferNews = (offerId, params) => dispatch => {
  dispatch({ type: offersConstants.SET_OFFER_NEWS_REQUEST });

  return offers
    .getOfferNews(offerId, params)
    .then((data = {}) => dispatch(setOfferNews(data.items)))
    .catch(err => ({ type: offersConstants.SET_OFFER_NEWS_FAILURE }));
};

// SET_OFFER_FILES
export const setOfferFiles = (files = []) => ({
  type: offersConstants.SET_OFFER_FILES_SUCCESS,
  files,
});

export const startSetOfferFiles = offerId => dispatch => {
  dispatch({ type: offersConstants.SET_OFFER_FILES_REQUEST });

  return offers
    .getOfferFiles(offerId)
    .then((data = {}) => dispatch(setOfferFiles(data.items)))
    .catch(err => ({ type: offersConstants.SET_OFFER_FILES_FAILURE }));
};

// SET_OFFER_PROMO
export const setOfferPromo = (promotions = []) => ({
  type: offersConstants.SET_OFFER_PROMO_SUCCESS,
  promotions,
});

export const startSetOfferPromo = params => dispatch => {
  dispatch({ type: offersConstants.SET_OFFER_PROMO_REQUEST });

  return news
    .getPromo(params)
    .then((data = {}) => dispatch(setOfferPromo(data.items)))
    .catch(err => ({ type: offersConstants.SET_OFFER_PROMO_FAILURE }));
};

export const resetOfferPromo = () => ({
  type: offersConstants.RESET_OFFER_PROMO,
});

// SET_OFFER_GROUPS_EXTRA
const setOfferExtraGroups = (groups = []) => ({
  type: offersConstants.SET_OFFER_EXTRA_GROUPS_SUCCESS,
  groups,
});

export const startSetOfferExtraGroups = (offerId, params) => dispatch => {
  dispatch({ type: offersConstants.SET_OFFER_EXTRA_GROUPS_REQUEST });

  return offers
    .getOfferExtraGroups(offerId, params)
    .then((data = {}) => dispatch(setOfferExtraGroups(data.items)))
    .catch(err => ({ type: offersConstants.SET_OFFER_EXTRA_GROUPS_FAILURE }));
};

// SET_OFFER_EXTRA_COLLECTION
export const setOfferExtraCollection = (groupId, collection, basePath) => ({
  type: offersConstants.SET_OFFER_EXTRA_COLLECTION_SUCCESS,
  basePath,
  groupId,
  collection,
});

export const startSetOfferExtraCollection = (offerId, groupId) => dispatch =>
  offers
    .getOfferExtraCollection(offerId, groupId)
    .then((data = {}) => dispatch(setOfferExtraCollection(groupId, data.items, data.base_path)));

//RECOMMENDED OFFERS
export const setRecommendedOffers = recommendedOffers => ({
  type: offersConstants.SET_RECOMMENDED_OFFERS_SUCCESS,
  recommendedOffers,
});

export const startSetRecommendedOffers = () => dispatch =>
  offers.getRecommendedOffers().then((data = {}) => dispatch(setRecommendedOffers(data.items)));

//SET_LANDINGS_INFO
export const setLandingsInfo = info => ({
  type: offersConstants.SET_LANDINGS_INFO,
  info,
});

export const startSetLandingsInfo = params => dispatch =>
  offers
    .getLandingInfo(params)
    .then((data = { items: [] }) => dispatch(setLandingsInfo(data.items[0])))
    .catch(({ response }) =>
      dispatch(
        setLandingsInfo({
          id: params.landingId,
          error: response.data.error.message.message,
        }),
      ),
    );

// SET_OFFER_SUPPORT_HOURS
export const startSetOfferSupportHours = (offerId, params) => dispatch =>
  offers
    .getOfferSupportHours(offerId, params)
    .then((data = { items: [] }) => dispatch(setOfferSupportHours(data.items)))
    .catch(err => ({ type: offersConstants.SET_OFFER_SUPPORT_HOURS_FAILURE }));
export const setOfferSupportHours = data => ({
  type: offersConstants.SET_OFFER_SUPPORT_HOURS_SUCCESS,
  supportHours: data,
});

// export const startSetMyTabIncrement = () => dispatch => dispatch({
//   type: offersConstants.SET_OFFER_TO_MY_SUCCESS_TAB_INCREMENT,
// });
